import Api from "./api.service";

class Vats {
  static getVats() {
    const params = {};
    return Api.get(`/api/v1/vats`, { params });
  }
}

const VatsService = Object.freeze(Vats);
export default VatsService;
